import { Button, Col, Form, Row, message } from "antd";
import DatePicker from "../../../../../components/inputs/MomentDatePicker";
import axios from "axios";
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { serverUrl } from "../../../../../nestserver";

function ClassAcademicSettings() {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();
  const [academicLastDate, setAcademicLastDate] = useState(null);
  const [transitionStartDate, setTransitionStart] = useState(moment());

  // fetch the school's default class dates
  async function fetchDefaultDates() {
    const res = await axios.get(serverUrl + "/classes/default-dates", {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  }
  const defaultDatesQuery = useQuery("classDefaultDates", fetchDefaultDates);
  const defaultDates = defaultDatesQuery.data;

  useEffect(() => {
    if (defaultDates) {
      form.setFieldsValue({
        academic_start_date: defaultDates.academic_start_date
          ? moment(defaultDates.academic_start_date)
          : undefined,
        academic_end_date: defaultDates.academic_end_date
          ? moment(defaultDates.academic_end_date)
          : undefined,
        transition_start_date: defaultDates.transition_start_date
          ? moment(defaultDates.transition_start_date)
          : undefined,
        transition_end_date: defaultDates.transition_end_date
          ? moment(defaultDates.transition_end_date)
          : undefined,
      });
      if (defaultDates.academic_end_date) {
        setAcademicLastDate(moment(defaultDates.academic_end_date));
      }
      if (defaultDates.transition_start_date) {
        setTransitionStart(moment(defaultDates.transition_start_date));
      }
    }
  }, [defaultDates, form]);

  // Save the school-wide default class dates
  function saveDefaultDates(values) {
    axios
      .patch(serverUrl + "/classes/default-dates", values, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        },
      })
      .then(() => {
        message.success("Default dates updated");
        queryClient.invalidateQueries("classDefaultDates");
      })
      .catch((error) => {
        if (error?.response?.data) {
          message.error(error?.response?.data.message);
        } else {
          message.error(error.message);
        }
      });
  }

  return (
    <div className="pt-8">
      <div
        style={{ borderRadius: "10px", color: "#616161" }}
        className=" bg-white drop-shadow-md p-8 w-full "
      >
        <div className="text-2xl text-orange-500 font-semibold pb-2">
          Class Academic Dates
        </div>
        <div className="text-sm text-gray-500 pb-6">
          These dates are pre-filled every time a new class is created.
        </div>
        <Form
          layout="vertical"
          name="classAcademicSettings"
          form={form}
          onFinish={saveDefaultDates}
          autoComplete="off"
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Academic Start Date"
                name="academic_start_date"
                rules={[{ required: true, message: "Please input a date" }]}
              >
                <DatePicker format="DD/MM/YYYY" className="w-full" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Academic End Date"
                name="academic_end_date"
                rules={[{ required: true, message: "Please input a date" }]}
              >
                <DatePicker
                  className="w-full"
                  onChange={(e) => setAcademicLastDate(e)}
                  format="DD/MM/YYYY"
                />
              </Form.Item>
            </Col>

            {academicLastDate && (
              <>
                <Col span={12}>
                  <Form.Item
                    label="Transition Start Date"
                    name="transition_start_date"
                    tooltip="Transistion period is the phase where Instructor/Admin can complete the Evalauations and Transfers to the next class"
                    rules={[{ required: true, message: "Please input a date" }]}
                  >
                    <DatePicker
                      className="w-full"
                      disabledDate={(d) =>
                        d.isBefore(moment(academicLastDate).add(1, "d"))
                      }
                      onChange={(d) => setTransitionStart(d)}
                      format="DD/MM/YYYY"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Transition End Date"
                    name="transition_end_date"
                    tooltip="Transistion period is the phase where Instructor/Admin can complete the Evalauations and Transfers to the next class"
                    rules={[{ required: true, message: "Please input a date" }]}
                  >
                    <DatePicker
                      className="w-full"
                      disabledDate={(d) => d.isBefore(transitionStartDate)}
                      format="DD/MM/YYYY"
                    />
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>
          <div className="flex justify-end items-center pt-6">
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              className="text-white"
            >
              Save Changes
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default ClassAcademicSettings;
